<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card class="overflow-y-hidden">
      <v-card-title class="d-flex align-center">
        <span>ESTIMACIONES GESTIÓN {{ gestion?.numero }}</span>

        <v-btn small class="ml-4" @click="descargarEstimacionesReporteGlobal">
          <v-icon>mdi-microsoft-excel</v-icon>
          Exportar
        </v-btn>
      </v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-tabs>
          <v-tab title="REPORTE CONSOLIDADO POR CUENTA Y SEDE"> REPORTE CONSOLIDADO POR CUENTA Y SEDE </v-tab>
          <v-tab title="REPORTE CONSOLIDADO POR SEDE Y MES"> REPORTE CONSOLIDADO POR SEDE Y MES </v-tab>
          <v-tab title="REPORTE POR SEDES"> REPORTE POR SEDES </v-tab>

          <v-tab-item class="item-tab">
            <ReporteConsolidadoPorSedeYMes
              :sedes="sedes"
              :estimacionesSedesPorPartidas="estimacionesSedesPorPartidas" />
          </v-tab-item>

          <v-tab-item class="item-tab">
            <ReporteConsolidadoPorPartidaYSede :estimacionesPorPartidaYSede="estimacionesPorPartidaYSede" />
          </v-tab-item>

          <v-tab-item class="item-tab">
            <ReportePorSedes :estimacionesPorSedes="estimacionesPorSedes" />
          </v-tab-item>
        </v-tabs>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ReporteConsolidadoPorSedeYMes from './ModalReportesGlobales/ReporteConsolidadoPorSedeYMes.vue';
import ReporteConsolidadoPorPartidaYSede from './ModalReportesGlobales/ReporteConsolidadoPorPartidaYSede.vue';
import ReportePorSedes from './ModalReportesGlobales/ReportePorSedes.vue';
import IngresosServices from './../services/ingresos';
import { formatearErrores, obtenerTodasLasSedes } from '../utils';
import ReportesExcelService from '../services/reportes-excel';
import DescargarExcelMixin from '../mixins/descargar-excel.mixin';

export default {
  name: 'ModalReportesGlobales',
  mixins: [DescargarExcelMixin],
  components: {
    ReporteConsolidadoPorSedeYMes,
    ReporteConsolidadoPorPartidaYSede,
    ReportePorSedes,
  },
  data() {
    return {
      gestion: null,
      visible: false,
      sedes: [],
      estimacionesSedesPorPartidas: [],
      estimacionesPorPartidaYSede: [],
      estimacionesPorSedes: [],
    };
  },
  methods: {
    abrir(gestion) {
      this.gestion = gestion;
      this.visible = true;
      this.estimacionesSedesPorPartidas = [];
      this.estimacionesPorPartidaYSede = [];
      this.estimacionesPorSedes = [];
      this.listarEstimacionesSedesPorPartidas();
      this.listarEstimacionesPorPartidaYSede();
      this.listarEstimacionesPorSedes();
    },
    cerrar() {
      this.visible = false;
      this.estimacionesSedesPorPartidas = [];
      this.estimacionesPorPartidaYSede = [];
      this.estimacionesPorSedes = [];
    },
    async listarEstimacionesSedesPorPartidas() {
      obtenerTodasLasSedes(this.$apollo)
        .then(async (sedes) => {
          this.sedes = sedes;

          try {
            const params = {
              gestion_id: this.gestion?.id,
              sedesIds: sedes.map((sede) => sede.id).join(','),
            };
            const response = await IngresosServices.getEstimacionesSedesPorPartidas({ params });

            this.estimacionesSedesPorPartidas = response.data.datos;
          } catch (error) {
            const { mensaje, errores } = error.response.data;
            const erroresFormateados = formatearErrores(errores);

            this.errores = errores;
            this.$notify({
              group: 'notifications',
              title: mensaje,
              text: erroresFormateados,
              type: 'error',
            });

            window.console.log(error);
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    async listarEstimacionesPorPartidaYSede() {
      try {
        const params = {
          gestion_id: this.gestion?.id,
        };
        const response = await IngresosServices.getEstimacionesPorPartidaYSede({ params });

        this.estimacionesPorPartidaYSede = response.data.datos;
      } catch (error) {
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.errores = errores;
        this.$notify({
          group: 'notifications',
          title: mensaje,
          text: erroresFormateados,
          type: 'error',
        });

        window.console.log(error);
      }
    },
    async listarEstimacionesPorSedes() {
      try {
        const params = {
          gestion_id: this.gestion?.id,
        };

        const response = await IngresosServices.getEstimacionesPorSedes({ params });

        this.estimacionesPorSedes = response.data.datos;
      } catch (error) {
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.errores = errores;
        this.$notify({
          group: 'notifications',
          title: mensaje,
          text: erroresFormateados,
          type: 'error',
        });

        window.console.log(error);
      }
    },
    descargarEstimacionesReporteGlobal() {
      return this.descargarExcel(ReportesExcelService.estimacionesReportesGlobales, null, {
        params: {
          gestion_id: this.gestion?.id,
          sedesIds: this.sedes.map((sede) => sede.id).join(','),
        },
      });
    },
  },
  computed: {},
};
</script>

<style scoped>
.item-tab {
  max-height: calc(100vh - 19rem);
  min-height: calc(100vh - 19rem);
  overflow-y: auto;
}
</style>